var blzEvent = require('../services/tracking/blz-event.js');

window.blz = window.blz || {};

var Mailtip = {
  load: function () {
    if ($('.mailtip').mailtip) return;
    blz.utils.loadjs(
      blz.globals.cdnPath + blz.globals.rawPath + '/assets/vendors/mailtip.js',
      Mailtip.run
    );
  },

  run: function () {
    $(function () {
      $('.mailtip').mailtip({
        mails: [
          'hotmail.com',
          'gmail.com',
          'yahoo.com.br',
          'outlook.com',
          'icloud.com',
          'bol.com.br',
          'uol.com.br',
          'live.com',
          'terra.com.br',
          'yahoo.com',
          'ig.com.br',
          'belezanaweb.com.br'
        ],
        onselected: function (email) {
          blzEvent.interaction(
            {},
            {
              category: (blz.pageName || '').toUpperCase(),
              action: 'Link-Click',
              label: 'Mailtip',
              values: 'email;' + email
            }
          );
        }
      });
    });
  }
};

blz.mailtip = Mailtip;

module.exports = Mailtip;
